import { cx } from '../utils/cx.js';

/** C-21 アバター（イニシャル）。24 / 32 / 40。在席の点は段 4 */
export function Avatar({ name, size = 32, className }: { name: string | null | undefined; size?: 24 | 32 | 40; className?: string }) {
  const initials = (name ?? '').replace(/\s+/g, '').slice(0, 2) || '?';
  const text = size === 24 ? 'text-tab-label' : size === 32 ? 'text-caption' : 'text-callout';
  return (
    <span
      aria-hidden="true"
      className={cx('inline-flex shrink-0 select-none items-center justify-center rounded-input bg-accent-fill font-medium text-accent', text, className)}
      style={{
        width: `calc(${size}px * var(--ui-icon-scale, 1))`,
        height: `calc(${size}px * var(--ui-icon-scale, 1))`,
      }}
    >
      {initials}
    </span>
  );
}
